<template>
  <div>
      <CCol class="text-right">
        <CButton 
          v-if="caseData && caseData.caseManagement && statusListLoaded" 
          :color="isCaseOpen ? 'danger' : 'success'" 
          shape="pill"
          size="sm" 
          @click="isCaseOpen ? showCloseDialog = true : showOpenDialog = true"
          class="mr-1 case-btn"
          :class="isCaseOpen ? 'close' : 'open'"
          v-c-tooltip="{ content: tooltipText, trigger: 'hover click' }"
        >
          <CIcon :name="isCaseOpen ? 'cil-power-standby' : 'cil-external-link'" size="sm" class="mr-0"/>
        </CButton>
        <span v-else class="text-muted">
          กำลังโหลดสถานะเคส...
        </span>
      </CCol>

    <!-- Open Case Modal -->
    <CModal
      title="เปิดเคส"
      :show.sync="showOpenDialog"
      :centered="true"
    >
      <template #body-wrapper>
        <div style="padding: 1rem;">
          <div class="form-group">
            <label>ชื่อผู้เปิดเคส *</label>
            <input type="text" class="form-control" v-model="openForm.userName" placeholder="กรอกชื่อผู้เปิดเคส"/>
          </div>
          <div class="form-group">
            <label>เหตุผล (ไม่บังคับ)</label>
            <textarea class="form-control" v-model="openForm.reason" placeholder="เหตุผลในการเปิดเคส" rows="3"></textarea>
          </div>
        </div>
      </template>
      <template #footer>
        <CButton class="mr-2" size="sm" color="danger" shape="pill" variant="outline" @click="showOpenDialog = false">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-ban" size="sm"/> CANCEL </span>
        </CButton>
        <CButton size="sm" color="success" shape="pill" variant="outline" @click="confirmOpenCase" :disabled="!openForm.userName">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-save" size="sm"/> SUBMIT </span>
        </CButton>
      </template>
    </CModal>

    <!-- Close Case Modal -->
    <CModal
      title="ปิดเคส"
      :show.sync="showCloseDialog"
      :centered="true"
      class="modal-rounded"
    >
      <template #body-wrapper>
        <div style="padding: 1rem;">
          <div class="form-group">
            <label>ชื่อผู้ปิดเคส <span style="color: red;">*</span></label>
            <input type="text" class="form-control" v-model="closeForm.userName" placeholder="กรอกชื่อผู้ปิดเคส"/>
          </div>
          <div class="form-group">
            <label>เหตุผล (ไม่บังคับ)</label>
            <textarea class="form-control" v-model="closeForm.reason" placeholder="เหตุผลในการปิดเคส" rows="3"></textarea>
          </div>
        </div>
      </template>
      <template #footer>
        <CButton class="mr-2" size="sm" color="danger" shape="pill" variant="outline" @click="showCloseDialog = false">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-ban" size="sm"/> CANCEL </span>
        </CButton>
        <CButton size="sm" color="success" shape="pill" variant="outline" @click="confirmCloseCase" :disabled="!closeForm.userName">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-save" size="sm"/> SUBMIT </span>
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'CaseControl',
  props: { caseId: String },
  data() {
    return {
      showOpenDialog: false,
      showCloseDialog: false,
      openForm: { userName:'', reason:'' },
      closeForm: { userName:'', reason:'' },
      statusListLoaded: false
    }
  },

  mounted() {
    this.$store.dispatch('FilterOptions/status').then(() => {
      console.log('statusList loaded:', this.statusList)
      this.statusListLoaded = true
    })
  },
  computed: {
    ...mapGetters({ 
      caseData: 'Dashboard2/case', 
      statusList: 'FilterOptions/status' 
    }),

     tooltipText() {
        return this.isCaseOpen ? 'ปิดเคส' : 'เปิดเคส';
      },
    isCaseOpen() {
      return this.caseData?.caseManagement?.isOpen || false;
    },
    statusInProgressId() {
      if (!this.statusList || this.statusList.length === 0) return null;
      const status = this.statusList.find(s => s.title.find(t => t.key==='th')?.value==='กำลังดำเนินการ');
      return status?._id || null;
    },
    statusUnderControlId() {
      if (!this.statusList || this.statusList.length === 0) return null;
      const status = this.statusList.find(s => s.title.find(t => t.key==='th')?.value==='ควบคุมได้แล้ว');
      return status?._id || null;
    }
  },

  watch: {
    statusList(newVal) {
      if (newVal && newVal.length > 0) {
        this.statusListLoaded = true;
      }
    }
  },

  methods: {
    async showAlert(options) {
      await Swal.fire({
        ...options,
        didOpen: () => {
          const el = document.querySelector('.swal2-container');
          if (el) el.style.zIndex = '11000';
        }
      });
    },

    async confirmOpenCase() {
      if (!this.openForm.userName) return this.showAlert({
        icon: 'warning', title: 'แจ้งเตือน', text: 'กรุณากรอกชื่อผู้เปิดเคส'
      });

      if (!this.statusInProgressId) return this.showAlert({
        icon:'warning', title:'รอสถานะโหลด', text:'กรุณารอสถานะเคสโหลดก่อน'
      });

      this.showOpenDialog = false;

      try {
        const res = await this.$store.dispatch('Dashboard2/openCase', {
          caseId: this.caseId,
          by: this.openForm.userName,
          reason: this.openForm.reason
        });

        if (res) {
          await this.$store.dispatch('Dashboard2/updateStatus', {
            reportId: this.caseId,
            statusId: this.statusInProgressId
          });

          this.openForm = { userName:'', reason:'' };
          this.$emit('case-opened', res);
          this.showAlert({ icon:'success', title:'สำเร็จ', text:'เปิดเคสสำเร็จ' });
        }
      } catch {
        this.showAlert({ icon:'error', title:'ข้อผิดพลาด', text:'ไม่สามารถเปิดเคสได้' });
      }
    },

    async confirmCloseCase() {
      if (!this.closeForm.userName) return this.showAlert({
        icon: 'warning', title: 'แจ้งเตือน', text: 'กรุณากรอกชื่อผู้ปิดเคส'
      });

      if (!this.statusUnderControlId) return this.showAlert({
        icon:'warning', title:'รอสถานะโหลด', text:'กรุณารอสถานะเคสโหลดก่อน'
      });

      this.showCloseDialog = false;

      try {
        const res = await this.$store.dispatch('Dashboard2/closeCase', {
          caseId: this.caseId,
          by: this.closeForm.userName,
          reason: this.closeForm.reason
        });

        if (res) {
          const carIds = (this.caseData.car || []).map(c => typeof c==='string'?c:c._id);
          await Promise.all(carIds.map(id => 
            this.$store.dispatch("Car/updateCar", { _id:id, status:"active", request_status:null })
          ));

          await this.$store.dispatch('Dashboard2/updateStatus', {
            reportId: this.caseId,
            statusId: this.statusUnderControlId
          });

          this.closeForm = { userName:'', reason:'' };
          this.$emit('case-closed', res);
          this.showAlert({ icon:'success', title:'สำเร็จ', text:'ปิดเคสสำเร็จ' });
        }
      } catch {
        this.showAlert({ icon:'error', title:'ข้อผิดพลาด', text:'ไม่สามารถปิดเคสได้' });
      }
    },
  }
}
</script>



<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  font-weight: 600;
  margin-bottom: 0.25rem;
  display: block;
}
.form-control {
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid #e9ecef;
}

.case-btn {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  line-height: 1.2;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.case-btn .mr-1 {
  margin-right: 0.25rem;
}

.case-btn.open {
  font-size: 0.75rem;
  color: #28a745 !important;
  border: 1px solid #28a745 !important;
  background-color: #fff !important;
}
.case-btn.open:hover:not(:disabled) {
  background-color: #28a745 !important;
  color: #fff !important;
  border-color: #28a745 !important;
}

.case-btn.close {
  font-size: 0.75rem;
  border: 1px solid #7c151f !important;
  color: #7c151f !important;
  background-color: #fff !important;
}
.case-btn.close:hover:not(:disabled) {
  background-color: #7c151f !important;
  color: #fff !important;
  border-color: #7c151f !important;
}

::v-deep .modal-rounded .modal-content {
  border-radius: 1rem !important;
}
</style>
